exports = module.exports = require("../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".fullpage-container{position:relative;width:100%;height:100%;overflow:hidden}.fullpage-wp{display:-ms-flexbox;display:flex;width:100%;height:100%;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-ms-flex-pack:start;justify-content:flex-start;-ms-flex-align:center;align-items:center}.fullpage-wp.anim{transform:translateZ(0);transition:all .5s ease-out 0s}.fullpage-wp.fullpage-wp-h{display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;-ms-flex-pack:start;justify-content:flex-start;-ms-flex-align:center;align-items:center}.page{box-sizing:border-box;display:block;position:relative;width:100%;height:100%;-ms-flex-negative:0;flex-shrink:0;overflow:hidden}.animated{opacity:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/vue-fullpage/vue-fullpage.css
// module id = 1108
// module chunks = 45